module.exports = __webpack_public_path__ + "img/image51.37ba8109.webp";